module.exports = __webpack_public_path__ + "img/duncan_laurence_juin2021.fb0c3036.jpg";